// extracted by mini-css-extract-plugin
export default {"default":"Default_default__JQKyj"};